"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _DOMSanitize = _interopRequireDefault(require("../../utils/DOMSanitize"));

var _inlineCSS = require("../../utils/inlineCSS");

var _constants = require("../../utils/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_OPTIONS = {
  shouldRemoveLargeAttachment: false,
  shouldAutoWrapParagraph: true,
  shouldRemoveDataURISchemeImageSource: true,
  shouldRemoveInvalidStyle: false
};

var sanitize = function sanitize(html, options) {
  options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  var doc = (0, _DOMSanitize["default"])(html, {
    removeLargeAttachment: options.shouldRemoveLargeAttachment,
    removeDataURISchemeImageSource: options.shouldRemoveDataURISchemeImageSource,
    handleImage: false,
    removeComposeInvalidStyle: options.shouldRemoveInvalidStyle,
    ALLOWED_ATTR: _constants.ALLOWED_ATTR,
    ALLOWED_TAGS: _constants.ALLOWED_TAGS,
    darkMode: options.darkMode,
    handleLinkText: true
  });
  (0, _inlineCSS.juice)(doc);
  return doc.body.innerHTML;
};

exports.sanitize = sanitize;
//# sourceMappingURL=sanitize.js.map